export const name = '@lifi/widget'
export const version = '4.10.1'
